// Contacts API Service - Centralized backend communication
const API_BASE = '/backend/api/contacts';

export const contactsApi = {
  // Fetch all contacts
  async fetchAll() {
    const response = await fetch(`${API_BASE}/list.php`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  // Add new contact
  async add(contact) {
    const response = await fetch(`${API_BASE}/add.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(contact)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  // Update existing contact
  async update(contact) {
    const response = await fetch(`${API_BASE}/update.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(contact)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  },

  // Delete contact
  async delete(contactId) {
    const response = await fetch(`${API_BASE}/delete.php?id=${contactId}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  }
};

